import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    return next.handle(request).pipe(
      catchError((err) => {
        if ([401, 403].includes(err.status) && token) {
          // auto logout if 401 or 403 response returned from api
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          this.router.navigate(['/login']);
        }

        const error = err.error?.errorKey;
        return throwError(() => error);
      }),
    );
  }
}
